import HtmlRenderer from "./HtmlRenderer";

function Banner({title, src}) {
  return (
    <>
      <div
        className="relative h-[10rem] sm:h-[15rem] w-screen bg-cover bg-center font-black text-black font-pretendard"
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute top-0 left-0 z-10 flex justify-center items-center w-full h-full px-5 md:text-4xl text-2xl text-center">
          <HtmlRenderer htmlString={title}/>
        </div>
        <div className="w-full h-full">
          <img
            src={require("../assets/banner/bg.png")}
            alt=""
            className="h-full w-full object-fill"
          />
        </div>
      </div>
    </>
  );
}

export default Banner;
